import { ActionButton } from '@juvare/common-data-table-ui/ActionButton';
import { useMediaQuery } from '@mui/material';
import React from 'react';
import { useAlertCreateButton } from '../../../hooks';
export const CreateNotificationButton = (props) => {
    const createAlertAction = useAlertCreateButton(props.alertsSentUrl);
    const upMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
    return (React.createElement(ActionButton, { anchor: upMd ? 'right' : undefined, fullWidth: !upMd, action: createAlertAction, variant: 'contained', "default-data-test": 'main-action-button' }));
};
